import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Container } from '@mui/material';
import Service from '../Service/Service';
import flouride from '../../../images/fluoride.png';
import cavity from '../../../images/cavity.png';
import whitening from '../../../images/whitening.png';
const services = [
    {
        name: 'Flouride Treatment',
        description: 'lorerrreekjznxczbbbkjbhzbc .fbusdbbhbbxzbc',
        img: flouride
    },
    {
        name: 'Cavity Fillling',
        description: 'lorerrreekjznxczbbbkjbhzbc .fbusdbbhbbxzbc',
        img: cavity
    },
    {
        name: 'Teetg Whitening',
        description: 'lorerrreekjznxczbbbkjbhzbc .fbusdbbhbbxzbc',
        img: whitening
    }
];
const Services = () => {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <Container>
                <Typography sx={{ fontWeight: 600, m: 2, color: "success.main" }} variant="h6" component="div">
                    OUR SERVICES
                </Typography>
                <Typography sx={{ fontWeight: 600, m: 2 }} variant="h4" component="div">
                    Services We Provide
                </Typography>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {services.map((service) => (
                        <Service key={service.name}
                            service={service}></Service>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Services;